<template>
  <div class="tender-menu">
    <div :class="['tm-total', { error: count.success !== count.total }]">[{{ count.success }}/{{ count.total }}]</div>
    <dl v-for="(chapter, i) in chapters" :key="i">
      <dt>
        <span class="tm-title">{{ chapter.Title }}</span>
      </dt>
      <dd v-for="(section, j) in chapter.Sections" :key="j" v-show="section.showMenu !== false">
        <span
          :class="['tm-title', 'limit', { on: tenderMenuOn === `tender-section-${i}-${j}` }]"
          :title="section.Title"
          @click="scrollToSection(i, j)"
          >{{ section.Title }}</span
        >
        <span :class="['tm-count', { error: validFaild(i, j) }]">[{{ sectionCount(i, j, "success") }}/{{ sectionCount(i, j, "total") }}]</span>
      </dd>
    </dl>
    <dl>
      <dd v-if="showComponentCTBA && modules.reportToCTBA">
        <span :class="['tm-title', 'limit', { on: tenderMenuOn == 'form-report-to-ctba' }]" @click="scrollToOtherSection('form-report-to-ctba')">
          推送到公共服务平台（国家）
        </span>
      </dd>
      <dd v-if="showComponentMail && modules.electronicMail">
        <span :class="['tm-title', 'limit', { on: tenderMenuOn == 'form-electronic-mail' }]" @click="scrollToOtherSection('form-electronic-mail')">
          电子保函
        </span>
      </dd>
    </dl>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import utils from "../js/utils";
export default {
  name: "TenderMenu",
  data() {
    return {
      watchCount: utils.doAtOneMinute(() => {
        this.calcTenderCount();
      }, 100),
    };
  },
  computed: {
    ...mapGetters("electronicMail", ["showComponentMail"]),
    ...mapGetters("reportToCTBA", ["showComponentCTBA"]),
    ...mapState(["count", "validatorCount", "tenderMenuOn", "scrollToId", "modules"]),
    ...mapGetters(["chapters"]),
  },

  methods: {
    ...mapMutations(["setTenderMenuOn"]),
    ...mapActions(["calcTenderCount", "setScrollToId"]),
    sectionCount(chapterIndex, sectionIndex, key) {
      return this.count.chapters[chapterIndex].sections[sectionIndex][key];
    },
    validFaild(chapterIndex, sectionIndex) {
      let section = this.count.chapters[chapterIndex].sections[sectionIndex];
      return section.success !== section.total;
    },
    scrollToSection(chapterIndex, sectionIndex) {
      this.setScrollToId(`tender-section-${chapterIndex}-${sectionIndex}`);
    },
    scrollToOtherSection(type) {
      this.setTenderMenuOn(type);
      this.setScrollToId(type);
    },
  },
  watch: {
    validatorCount() {
      this.watchCount();
    },
  },
};
</script>
<style lang="scss" scoped>
$fontFamily: microsoft yahei;
.tender-menu {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: auto;
  // padding: 0px 10px 10px 15px;
  padding: 0px 0 10px 0;
  background-color: #f5f7f9;
  .tm-total {
    padding: 15px 10px 3px 3px;
    position: sticky;
    z-index: 1;
    top: 0;
    text-align: right;
    color: green;
    background: #f5f7f9;
    font: normal 16px/30px $fontFamily;
    &.error {
      color: red;
    }
  }
  dl {
    margin: 0 10px 0 15px;
    font: normal 14px/23px $fontFamily;
    dt {
      margin: 1px 0;
      display: flex;
      font-weight: bold;
      cursor: pointer;
    }
    dd {
      margin: 1px 0;
      display: flex;
      text-indent: 20px;
      flex-direction: row;
      margin-inline-start: 0px;
      cursor: pointer;
    }
    .tm-title {
      flex: 1;
      padding: 0 3px;
      color: #262e3e;
      &.limit {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &:hover,
      &.on {
        background: #c6ced6;
      }
    }
    .tm-count {
      width: 70px;
      color: green;
      font-size: 15px;
      text-indent: 0;
      text-align: right;
      &.error {
        color: red;
      }
    }
  }
}
</style>